import React from 'react';
import { Box, Typography, Divider } from '@mui/material';
import { FieldEntry } from '../hooks';
import FieldRow from './FieldRow';

interface FieldSectionProps {
  title: string;
  fields: FieldEntry[];
}

const FieldSection: React.FC<FieldSectionProps> = ({ title, fields }) => {
  if (fields.length === 0) return null;

  return (
    <Box sx={{ mb: 3 }}>
      <Typography
        variant="subtitle1"
        sx={{
          fontWeight: 700,
          textTransform: 'uppercase',
          letterSpacing: '0.05em',
          color: 'text.primary',
          mb: 1,
        }}
      >
        {title}
      </Typography>
      <Divider sx={{ mb: 1 }} />
      {fields.map((f) => (
        <FieldRow key={f.label} label={f.label} value={f.value} />
      ))}
    </Box>
  );
};

export default React.memo(FieldSection);
